<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      size="lg"
      title="รายการที่ถูกพักไว้"
      hide-footer
      footer-class="pt-0 border-0"
    >
      <b-row>
        <b-col>
          <b-table
            responsive
            striped
            hover
            :fields="fields"
            :items="items"
            :busy="isBusy"
            show-empty
            empty-text="No matching records found"
            class="table-main oveflow-auto table-custom"
            :no-border-collapse="false"
          >
            <template v-slot:cell(id)="data">
              <b-button
                variant="primary-color"
                class="btn-modal btn-hover"
                @click="handleBilling(data.item.id)"
              >
                เลือก
              </b-button>
            </template>
            <template v-slot:cell(customer_name)="{ item }">
              {{ item.first_name_th + " " + item.last_name_th }}
              <div>
                <small>{{ item.member_id }}</small>
              </div>
              <div>
                <small>{{ item.is_company ? "Company" : "Personal" }}</small>
              </div>
            </template>
            <template v-slot:cell(record_created_time)="data">
              <div
                v-if="data.item.record_created_time != '0001-01-01T00:00:00'"
              >
                {{
                  $moment(data.item.record_created_time)
                    .add(543, "years")
                    .format($formatDateNewFull)
                }}
              </div>
              <div v-else>-</div>
            </template>
            <template v-slot:cell(grand_total)="data">
              {{ data.item.grand_total | numeral("0,0.00") }}
            </template>
            <template v-slot:cell(action)="data">
              <font-awesome-icon
                icon="trash-alt"
                class="pointer"
                @click="removeItems(data.item.id)"
              ></font-awesome-icon>
            </template>
            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <Pagination
        page="skip"
        @handleChangeTake="handleChangeTake"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />
    </b-modal>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import OtherLoading from "@/components/loading/OtherLoading";

export default {
  props: {
    paymentChannelList: {
      require: true,
      type: Array,
    },
    isFullPos: {
      require: false,
      type: [Number, String],
    },
  },
  components: {
    OtherLoading,
    Pagination,
  },
  data() {
    return {
      filter: {
        skip: 0,
        take: 5,
        search: "",
      },
      rows: 0,
      items: [],
      isBusy: false,
      showModal: false,
      fields: [
        {
          key: "id",
          label: "",
        },
        {
          key: "customer_name",
          label: "ลูกค้า",
          tdClass: "text-left",
        },
        {
          key: "record_created_time",
          label: "วันที่/เวลา",
        },
        {
          key: "quantity",
          label: "จำนวนชิ้น",
        },
        {
          key: "grand_total",
          label: "จำนวนราคาสุทธิ",
        },
        {
          key: "action",
          label: "",
        },
      ],
    };
  },
  methods: {
    async getBillHolding() {
      this.isBusy = true;
      const res = await this.$axios.post(
        `${this.$baseUrl}/transaction/get_hold_transaction_list`,
        this.filter
      );
      this.isBusy = false;
      this.items = res.detail.detail;
      this.rows = res.detail.total_count;
    },
    async show() {
      this.getBillHolding();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    async handleBilling(id) {
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.$axios(
        `${this.$baseUrl}/transaction/get_hold_transaction/${id}`
      );

      this.$emit("loadBill", res.detail.json, id);
      await this.callRemoveItems(id);
      await this.$store.dispatch("setMainLoading", false);
      // await this.$store.dispatch("setMainLoading", true);
    },
    handleChangeTake(val) {
      this.filter.take = val;
      this.filter.skip = 0;
      this.getBillHolding();
    },
    pagination(val) {
      this.filter.skip = val - 1;
      this.getBillHolding();
    },
    async callRemoveItems(id) {
      const res = await this.$axios.delete(
        `${this.$baseUrl}/transaction/delete_hold_transaction/${id}`,
        this.filter
      );
      return res;
    },
    async removeItems(id) {
      this.confirmAlert().then(async ({ isConfirmed }) => {
        if (!isConfirmed) return;
        const res = await this.callRemoveItems(id);
        if (res.result) this.getBillHolding();
        else this.errorAlert(res.message);
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
